import { cookieGetters } from '@/helpers/cookieManager';
export default () => {
    const {email = ''} = cookieGetters.getUserProfile() || {};
    // eslint-disable-next-line no-undef
    profitwell('start', {'user_email': email});
    // it using the new value of MIX_PW_AUTH - Release 7.4.0
};